import { ColorScheme } from '../types/theme';

export const THEME: ColorScheme = {
    dark: {
        primaryColor: '#008c94',
        secondaryColor: '#698A9C',
        primaryBackgroundColor: '#121212',
        secondaryBackgroundColor: '#000000',
        primaryTextColor: '#E0E0E0',
        secondaryTextColor: '#B0B0B0',
        thinBorderColor: 'rgb(242, 242, 247)',
        sectionBackgroundColor: '#000',
        sectionTextColor: '#FFF',
        sidebarTextColor: '#000',
        sidebarActiveColor: 'rgba(0, 140, 148, 0.6)',
        sidebarHoverColor: 'rgba(105, 138, 156, 0.6)',
        footerBackgroundColor: 'rgb(242, 242, 247)',
        footerTextColor: 'rgb(99, 99, 102)',
        invalidBorderColor: '#ff0000',
        invalid: '#D32F2F',
        warning: '#FF9800'
    },
    light: {
        primaryColor: '#008c94',
        secondaryColor: '#698A9C',
        primaryBackgroundColor: '#fafafc',
        secondaryBackgroundColor: '#FFFFFF',
        primaryTextColor: '#000000',
        secondaryTextColor: '#4A4A4A',
        thinBorderColor: 'rgb(242, 242, 247)',
        sectionBackgroundColor: '#000',
        sectionTextColor: '#FFF',
        sidebarTextColor: '#000',
        sidebarActiveColor: 'rgba(0, 140, 148, 0.6)',
        sidebarHoverColor: 'rgba(105, 138, 156, 0.6)',
        footerBackgroundColor: 'rgb(242, 242, 247)',
        footerTextColor: 'rgb(99, 99, 102)',
        invalidBorderColor: '#ff0000',
        invalid: '#D32F2F',
        warning: '#FF9800'
    }
};
